import React, { useState, useEffect } from 'react';

const Toast = ({ message, type = 'info', duration = 3000 }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration]);

  if (!visible) return null;

  const typeStyles = {
    success: 'bg-green-600 text-white',
    error: 'bg-[#FF4D4D] text-white',
    info: 'bg-[#1B1B1F] text-white',
  };

  return (
    <div
      dir="rtl"
      className={`
        fixed bottom-5 right-5 z-50
        min-w-[280px] max-w-md
        px-5 py-4
        rounded-2xl
        shadow-[0_4px_20px_rgba(27,27,31,0.15)]
        border-l-4 border-[#F2B705]
        animate-fade-in-up
        ${typeStyles[type]}
      `}
    >
      <p className="font-medium text-sm">{message}</p>
    </div>
  );
};

export default Toast;
